module.exports = __webpack_public_path__ + "4336677bb1fbd65733809573bb256682.svg";